export const SET_SYMBOLES = 'SET_USER';
export const FILLER = 'DO NOT USE';
export const SET_PARAMETRAGES = 'SET_PARAMETRAGE';
export const SET_PARAM_AFFIXE2 = 'SET_PARAM_AFFIXE2';
export const SET_ACTIVATION_YIELD = 'SET_ACTIVATION_YIELD';



// WEBPACK FOOTER //
// ./src/store/modules/parametrage-mutation-type.js